import type { NoodlNode } from '@shared/node-v1.0.0'
import { sendOutput, sendSignal } from '@shared/port-send-v1.0.0'
import type { Props } from '../node/definition'

export const fetch = async (p: Props, noodlNode: NoodlNode, refetch?: boolean) => {
	const { db, PreparedQuery, setItems } = R.surreal
	if (!p.query) return

	const startTime = log.start()
	log.info('useData props', p)

	const MantineError = R.libs.mantine?.MantineError

	if (!refetch) {
		noodlNode._internal.fetching = true
		sendOutput(noodlNode, 'fetching', true)
	}

	let response: unknown[] | undefined

	try {
		const preparedQuery = new PreparedQuery(p.query)
		response = await db.query(preparedQuery)
	} catch (e: any) {
		// Здесь именно message, т.к. Surreal готовит текст с подсветкой места ошибки в запросе.
		log.error('useData fetch:', e.message)
		MantineError('Системная ошибка!', `useData fetch error: ${e.message}`)
		return
	}

	setItems(response, true)
	p.store.response = response

	sendOutput(noodlNode, 'response', response)
	sendSignal(noodlNode, 'fetched')

	if (!refetch) {
		noodlNode._internal.fetching = false
		sendOutput(noodlNode, 'fetching', false)
	}

	log.info('useData response', response)
	log.end('useData', startTime)
}
